import { Routes } from '@angular/router';
import { roleGuard, loggedInGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'admin/dashboard',
    canActivate: [roleGuard(['admin'])],
    loadComponent: () =>
      import('./features/dashboard/dashboard-page.component').then(
        m => m.DashboardPageComponent,
      ),
  },
  {
    path: 'accounting/dashboard',
    canActivate: [roleGuard(['admin'])],
    loadComponent: () =>
      import('./features/accounting-dashboard/accounting-dashboard-page.component').then(
        m => m.AccountingDashboardPageComponent,
      ),
  },
  {
    path: 'customer-care/dashboard',
    canActivate: [roleGuard(['admin'])],
    loadComponent: () =>
      import('./features/customer-care-dashboard/customer-care-dashboard-page.component').then(
        m => m.CustomerCareDashboardPageComponent,
      ),
  },
  {
    path: 'client/dashboard',
    canActivate: [roleGuard(['client'])],
    loadComponent: () =>
      import('./features/client-dashboard/client-dashboard-page.component').then(
        m => m.ClientDashboardPageComponent,
      ),
  },
  {
    path: 'provider/dashboard',
    canActivate: [roleGuard(['provider'])],
    loadComponent: () =>
      import('./features/provider-dashboard/provider-dashboard-page.component').then(
        m => m.ProviderDashboardPageComponent,
      ),
  },
  {
    path: 'login',
    canActivate: [loggedInGuard],
    loadComponent: () =>
      import('./features/login/login-page.component').then(
        m => m.LoginPageComponent,
      ),
  },
  { path: '', redirectTo: 'admin/dashboard', pathMatch: 'full' },
];
